import store from "@/store";
import BaseModel from "./BaseModel";
import CourseService from "@/services/CourseService";

/**
 * Context
 */
export default class Context extends BaseModel{

  constructor() {
    super();
    this.user = null;
    this.userLang = 'pt';
    this.courses = [];
    this.coursesUuid = [];

    this.loadContext();
  }

  /**
   * Loads context information such as logged user courses
   */
  async loadContext() {
    this.user     = store.getters.getUser;
    this.userLang = store.getters.getUserLang ?? 'pt';

    await this.setUserCourses();
  }

  /**
   * Gets and sets Logged User courses
   */
  async setUserCourses() {
    const response = await CourseService.getLoggedStudentCourses();
    if (response.success()) {
      let courseUuid = [];
      for (let course of response.getContent().courses) {
        courseUuid.push(course.uuid);
      }

      this.courses = response.getContent().courses;
      this.coursesUuid = courseUuid;
    }
  }

  /**
   * Gets course by uuid
   * @param {String} uuid
   * @returns {Course|False} 
   */
  getCourse(uuid = '') {
    if (!this.coursesUuid.includes(uuid))
      return false;

    for (let course of this.courses) {
      if (course.uuid == uuid)
        return course;
    }
    return false;
  }

  /**
   * Checks if uuid is one of my courses
   * @param {String} uuid
   * @returns {Boolean} 
   */
  isMyCourse(uuid = '') {
    return this.coursesUuid.includes(uuid);
  }
}